
import { useState } from "react";
import { useParams } from "react-router-dom";
import { TableHead, TableRow, TableCell, TableBody } from "@mui/material";
import { DisenioOrdenCompra, LayoutTabla } from "../../layout";
import { useOrdenCompraXID, useProductosOC, useValidarRoles } from "../../../hooks";
import { BotonesGroup, CargandoMedio, ModalFormUno } from "../../components";
import { startAprobarXRol } from "../../../services";
import { useQueryClient } from "@tanstack/react-query";
import { FormularioCrearFactura, TablaOCDetalles } from "../../components/facturas";
import { useAuthStore, useModalesStore } from "../../../store";

import dayjs from 'dayjs';




export const OrdenCompraDetalles = () => {


    const { id } = useParams();
    const { usuario } = useAuthStore();
    const queryClient = useQueryClient();
    const { isRolPermitido } = useValidarRoles();
    const { changeEstadoModalUno } = useModalesStore(); 
    const { data, isLoading } = useOrdenCompraXID(id);
    const aprobado = (data && data.aprobaciones.some( item => item.rol === usuario?.role));
    const { selected, setItemsFinal, handleClick, handleSelectAllClick, handlePrecioChange, isSelected, itemsFinal } = useProductosOC(data?.items || []);

    const [cargando, setCargando] = useState(false);



    const handleAprobarUser = async() => {
        setCargando(true);
        const resp = await startAprobarXRol(id);
        setCargando(false);

        if( resp ) queryClient.invalidateQueries({queryKey: ['ordencompra-id']});
    }


    const botonesOpciones = [
        { label: aprobado ? 'Ya aprobaste' : 'Aún no apruebas', onClick: handleAprobarUser, icono:'save', disabled:aprobado },
        { label: "Generar Factura", onClick:() => changeEstadoModalUno(true), icono:'save', disabled:(selected.length < 1) },
    ];


    return (

        <DisenioOrdenCompra titulo="Detalles Orden de Compra">
            {( isLoading )
            ?   <CargandoMedio titulo="Cargando información detalle ordene de compra" />

            :   <>
                {(isRolPermitido(['SUPERADMIN', 'ADMIN', 'SECRETARIA'])) &&
                    <BotonesGroup botonesOpciones={botonesOpciones} disabled={cargando}  />
                }

                <TablaOCDetalles 
                    selected={ selected }
                    handleClick={ handleClick }
                    handleSelectAllClick={ handleSelectAllClick }
                    handlePrecioChange={ handlePrecioChange }
                    isSelected={ isSelected }
                    itemsFinal={ itemsFinal }
                />

                <LayoutTabla>
                    <TableHead>
                        <TableRow>
                            <TableCell sx={{ width: "20%" }}>Rol</TableCell>
                            <TableCell sx={{ width: "35%" }}>Usuario</TableCell>
                            <TableCell sx={{ width: "25%" }}>Estado</TableCell>
                            <TableCell sx={{ width: "20%" }}>Fecha</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {data?.aprobaciones && data.aprobaciones.length > 0 
                        ?   (
                            data.aprobaciones.map((d, i) => (
                            <TableRow key={i}>
                                <TableCell>{d.rol}</TableCell>
                                <TableCell>{d.usuario.nombre}</TableCell>
                                <TableCell>{(d.aprobado) ? 'APROBADO': 'NO-APROBADO'}</TableCell>
                                <TableCell>{dayjs(d.fecha).format("DD/MM/YYYY HH:mm")}</TableCell>
                            </TableRow>
                        ))) 
                        :   <TableRow><TableCell colSpan={4} align="center"> No hay aprobaciones</TableCell></TableRow>
                        }
                    </TableBody>
                </LayoutTabla>
                </>
            }


            <ModalFormUno titulo={`Crear Factura`} valor={{}} onClose={() => changeEstadoModalUno(false)}>
                <FormularioCrearFactura selected={ selected } setItemsFinal={ setItemsFinal } />
            </ModalFormUno>
        </DisenioOrdenCompra>
    )
}
